import { configureStore } from "@reduxjs/toolkit";
import usersReducer from "./usersSlice";
import locationsReducer from "./locationsSlice";
import eventSessionTypesReducer from "./eventSessionTypesSlice"
import delegateRolesReducer from "./delegateRolesSlice"
import delegateRoleGroupsReducer from "./delegateRoleGroupsSlice"
import eventsReducer from "./eventsSlice"
import categoriesReducer from "./eventCategoriesSlice"
import ticketsReducer from "./ticketsSlice"
import lookupReducer from "./lookupSlice";
import chatReducer from "./chatSlice";
import aiActionSlice from './aiActionSlice';
import scoreReducer from './scoreSlice';

import podsReducer from './podsSlice';

const store = configureStore({
    reducer: {
        events: eventsReducer,
        users: usersReducer,
        locations: locationsReducer,
        eventSessionTypes: eventSessionTypesReducer,
        delegateRoles: delegateRolesReducer,
        delegateRoleGroups: delegateRoleGroupsReducer,
        eventCategories: categoriesReducer,
        tickets: ticketsReducer,
        lookup: lookupReducer,
        chat: chatReducer,
        aiAction: aiActionSlice,
        pods: podsReducer,
        score: scoreReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: {
                extraArgument: {}
            },
        }),
});

// Expose store globally for chat window logic
if (typeof window !== 'undefined') {
    (window as any).store = store;
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;